import { useTranslation } from "react-i18next";
import { Grid, Row, Col } from "rsuite";
import ShortCutPanel, { types } from "../components/ShortcutPanel";
import DeviceIcon from "@rsuite/icons/Device";
import StorageIcon from "@rsuite/icons/Storage";
import MobileIcon from "@rsuite/icons/Mobile";
import { Icon } from "@rsuite/icons";
import { RiWindowsLine } from "react-icons/ri";
import { FaLinux } from "react-icons/fa";
import { FaApple } from "react-icons/fa";
import { HiRocketLaunch, HiRectangleGroup } from "react-icons/hi2";

const DashboardShortcuts = () => {
  const [t] = useTranslation();

  return (
    <Grid fluid>
      <Row>
        <Col xs={24} sm={24} lg={8}>
          <ShortCutPanel
            type={types.primary}
            title={t("all-devices-panel.all-devices")}
            paragraph={t("main-sidebar.dashboard")}
            href={"/dashboard"}
            icon={<DeviceIcon />}
            className={"content-init"}
          />
        </Col>
        <Col xs={24} sm={24} lg={8}>
          <ShortCutPanel
            type={types.primary}
            title={"Windows"}
            paragraph={t("main-sidebar.dashboard")}
            href={"/dashboard/windows"}
            icon={<Icon as={RiWindowsLine} />}
            className={"content-center"}
          />
        </Col>
        <Col xs={24} sm={24} lg={8}>
          <ShortCutPanel
            type={types.primary}
            title={"Linux"}
            paragraph={t("main-sidebar.dashboard")}
            href={"/dashboard/linux"}
            icon={<Icon as={FaLinux} />}
            className={"content-end"}
          />
        </Col>
        <Col xs={24} sm={24} lg={8}>
          <ShortCutPanel
            type={types.primary}
            title={t("main-sidebar.mobile")}
            paragraph={t("main-sidebar.dashboard")}
            href={"/dashboard/mobile"}
            icon={<MobileIcon />}
            className={"content-init"}
          />
        </Col>
        <Col xs={24} sm={24} lg={8}>
          <ShortCutPanel
            type={types.primary}
            title={t("main-sidebar.servers")}
            paragraph={t("main-sidebar.dashboard")}
            href={"/dashboard/servers"}
            icon={<StorageIcon />}
            className={"content-center"}
          />
        </Col>
        <Col xs={24} sm={24} lg={8}>
          <ShortCutPanel
            type={types.primary}
            title={"Apple"}
            paragraph={t("main-sidebar.dashboard")}
            href={"/dashboard/apple"}
            icon={<Icon as={FaApple} />}
            className={"content-end"}
          />
        </Col>
        <Col xs={24} sm={24} lg={8}>
          <ShortCutPanel
            type={types.primary}
            title={t("main-sidebar.mission-control")}
            paragraph={t("main-sidebar.dashboard")}
            href={"/dashboard/mission-control"}
            icon={<Icon as={HiRocketLaunch} />}
            className={"content-init"}
          />
        </Col>
        <Col xs={24} sm={24} lg={8}>
          <ShortCutPanel
            type={types.primary}
            title={t("main-sidebar.mission-control-2")}
            paragraph={t("main-sidebar.dashboard")}
            href={"/dashboard/mission-control-2"}
            icon={<Icon as={HiRectangleGroup} />}
            className={"content-center"}
          />
        </Col>
      </Row>
    </Grid>
  );
};

export default DashboardShortcuts;
